<template>
  <section class="section container services row" :class="`section--${shadeMode}`">
		<home-heading :content="content.title"
									class="section__heading" />
    <div class="services__container">
			<div v-for="service in content.services">
				<nuxt-link :to="localePath(`/${service.slug.current}`)"
									 class="services__service">
					<img :src="$urlFor(service.hero.asset.url, 800)"
									 :alt="locale === 'en' ? service.heroAlt.en : service.heroAlt.jp"
									 class="service__image"
									 loading="lazy"
									 :height="service.hero.asset.metadata.dimensions.height"
									 :width="service.hero.asset.metadata.dimensions.width" />
					<div class="service__panel"></div>
					<h3 class="service__title">{{ locale === 'en' ? service.title.en : service.title.jp }}</h3>
				</nuxt-link>
			</div>
    </div>
  </section>
</template>

<script setup>
import { useI18n, useLocalePath } from '#imports'
import { computed } from 'vue'
const { locale } = useI18n()
const localePath = useLocalePath()
const props = defineProps({
  content: Object
})
let shadeMode = props.content.isDarkMode === true ? 'dark' : 'light'
let servicesHeading
if(props.content.title) {
  servicesHeading = computed(() => locale.value === 'en' ? props.content.title.en : props.content.title.jp)
}
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.services {
  display: block;
  max-width: 100%;
	padding: 1rem;
	@include v.respond-to('medium') {
		padding: 2rem 3rem;
	}
  &__container {
    box-sizing: border-box;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 100%;
    margin: 0 0 1rem 0;
    width: 100%;
    @include v.respond-to('medium') {
			grid-gap: 1rem;
			grid-template-columns: repeat(5, 1fr);
    }
  }
  &__service {
    display: block;
    height: 15rem;
    overflow: hidden;
    position: relative;
    transition: all 0.3s;
    .service__image {
      height: 100%;
      object-fit: cover;
      transition: 0.3s;
      width: 100%;
    }
    .service__panel {
      background-color: rgba(0,174,187,0);
      bottom: 0;
      display: block;
      height: 100%;
      position: absolute;
      width: 100%;
    }
    .service__title {
      background-color: v.$transparentBg--strong;
      bottom: 0.5rem;
      display: block;
			font-size: v.$font-size;
      left: 0.5rem;
      margin: 0;
      padding: 1rem;
      position: absolute;
      vertical-align: bottom;
      width: auto;
    }
    &:hover {
      .service__panel {
        background-color: rgba(0,174,187,0.85);
        transition: all 0.3s;
      }
      .service__title {
        background-color: rgba(0,0,0,0);
        transition: 0.2s;
      }
      .service__image {
        transform: scale(1.05);
        transition: 0.3s;
      }
    }
  }
}
</style>
